import React from 'react';

const Line = ({ color = 'rgba(255,255,255,0.3)', className }) => {
  return <div style={{ borderTop: `0.33px solid ${color}` }} className={className}></div>;
};

export default Line;
